// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"RecommendationsList_listContainer__zOMv6","listTitle":"RecommendationsList_listTitle__pJJNc","halfWidth":"RecommendationsList_halfWidth__ejpzI"};